export default {
  name: {
    short: "MQSA",
    long: "Mammography Quality Standards Act",
  },
};
